import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as actions from './redux/actions'
import Avatar from '@material-ui/core/Avatar'
import { NavLink } from 'react-router-dom'
import { REACT_APP_IMG } from '../../common/config'
import UserIcon from '../../images/user-icon.svg'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Tooltip }  from '@material-ui/core';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import {checkPermission} from '../common/hooks/useCheckPermission';
import Fade from "@material-ui/core/Fade";

export class UserInfo extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
  }
  
  componentDidMount(){
    this.firstRender=true
  }

  componentDidUpdate(pp){
    if(pp.user.permissions!=this.props.permissions){
      this.hasAnyPermission = checkPermission("HAS_ANY", pp.user.permissions)
    }
    this.firstRender=false
  }

  handleAvatarClick = () => {
    this.props.forceCloseNotifications()
    this.props.closeSideMenu()
  }
 
  render() {
    const theme = createTheme({
      overrides: {
        MuiTooltip: {
          tooltip: {
            fontSize: '12px',
            fontWeight: '500',
            lineHeight: '16px',
            backgroundColor: '#4B4B4B',
            borderRadius: '5px',
            width: '262px',
            height:'36px',
            display:'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderColor: '#4B4B4B'
          },
          arrow:{
            color:'#4B4B4B'
          }
        },
      },
    });

    const thumbnailUrl = this.props.user.photo;
    const thumbnail = thumbnailUrl ? `${REACT_APP_IMG}/${thumbnailUrl}` : null
    const mensajeTooltip = "El perfil de usuario ya no está disponible."
    return (
      <NavLink to="/usuarios/editar-usuario"  className="nav-link">
      <div className="home-user-info" onClick={()=> this.props.isMobile ? this.handleAvatarClick() : null}>
        <div className="user-info">
          <div className={`header-user__name ${!this.hasAnyPermission ? "without-permission" : ""}`}>
            {this.props.user.firstname + ' ' + this.props.user.lastname}
          </div>
          <div className={`header-user__role ${!this.hasAnyPermission ? "without-permission" : ""}`}>
            {this.props.user.role_name || ''} 
            {!this.hasAnyPermission && !this.firstRender &&
              <ThemeProvider theme={theme}>
                  <Tooltip 
                  title={mensajeTooltip} 
                  arrow
                  placement="left" 
                  TransitionComponent={Fade}
                  >
                    <ErrorOutlineIcon className='icon-exclamation'></ErrorOutlineIcon>
                  </Tooltip>
              </ThemeProvider>
            }
          </div>
        </div>
        {thumbnail ? 
          <Avatar className="header-user__avatar" alt={this.props.user.firstname} src={thumbnail} /> :
          <Avatar className="header-user__avatar no-image" alt="user-icon" src={UserIcon} />
        }
      </div>
      </NavLink>
    )
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.common.user,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo)
